export enum IQErrorReasonTypes {
  Error = 0,
  ValueAdjusted = 1,
  Warning = 2,
}
